import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './MobileNavBar.css';

const MobileNavBar: React.FC = () => {
  const location = useLocation();
  return (
    <nav className="mobile-nav-bar">
      <Link to="/" className={location.pathname === '/' ? 'active' : ''}>
        <i className="fa fa-home"></i>
        <span>Home</span>
      </Link>
      <Link to="/shop" className={location.pathname.startsWith('/shop') ? 'active' : ''}>
        <i className="fa fa-th-large"></i>
        <span>Shop</span>
      </Link>
      <Link to="/cart" className={location.pathname.startsWith('/cart') ? 'active' : ''}>
        <i className="fa fa-shopping-cart"></i>
        <span>Cart</span>
      </Link>
      <Link to="/wishlist" className={location.pathname.startsWith('/wishlist') ? 'active' : ''}>
        <i className="fa fa-heart"></i>
        <span>Wishlist</span>
      </Link>
      <Link to="/profile" className={location.pathname.startsWith('/profile') ? 'active' : ''}>
        <i className="fa fa-user"></i>
        <span>Profile</span>
      </Link>
    </nav>
  );
};

export default MobileNavBar;
